import { styled } from "styled-components"
import Header from "../../home/main/header"
import TraumPath from "./traumPath"

const Main = () => {
  return(
    <Container>
      <Header />
      <TraumPath />
    </Container>
  )
}


export default Main

const Container = styled.main`
  background:url(/imgs/about/background/thumbnail1.jpg) no-repeat center center/cover;
  height:1035px;
`